<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <h1 class="headline">{{ action }} Devotional Completion Rank</h1>
          </v-card-title>
          <v-card-text>
            <v-alert
              v-model="isError"
              dismissible
              type="error"
              transition="fade-transition"
            >
              {{ errMessage }}
            </v-alert>

            <v-text-field
              v-model="rank.title"
              label="Title"
              :error-messages="errors.title"
              id="title"
              @focus="inputFocus"
            />

            <v-text-field
              v-model="rank.requirement"
              label="Requirement"
              :error-messages="errors.requirement"
              id="requirement"
              @focus="inputFocus"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="submit"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    rank: {
      title: '',
      requirement: 0
    },

    isError: false,
    errMessage: null,
    errors: {
      title: null,
      requirement: null
    }
  }),
  computed: {
    action: function () {
      let id = this.$route.params.id
      if (id === 'new') {
        return 'Add'
      } else {
        return 'Edit'
      }
    }
  },
  mounted: function () {
    let id = this.$route.params.id
    // If we're making a new rank, we're done
    if (id === 'new') {
      return
    }

    // Otherwise, we need to load data for the rank
    this.axios.get('/devotionals/completions/ranks/' + id)
      .then((res) => {
        // Sanity check before assigning the value
        if (res.data.length > 0) {
          this.rank = res.data[0]
        } else {
          throw new RangeError('No devotional completion rank information returned')
        }
      })
      .catch(this.$root.apiErrorHandler((msg, errors, err) => {
        // If our error is a 404, that means we got a bogus set ID value and
        // we can safely abort back to the rank listing page. Otherwise, we want
        // to render our error message.
        if (err && err.response && err.response.status === 404) {
          return this.$router.push('/admin/devotional-completion-ranks')
        } else {
          this.errMessage = msg
          this.isError = true
        }
      }))
  },
  methods: {
    submit: function (ev) {
      // Set up the proper request based on whether we're editing or creating
      let url = '/devotionals/completions/ranks'
      let method = 'POST'
      let id = this.$route.params.id
      if (id !== 'new') {
        url += '/' + id
        method = 'PUT'
      }

      // Now send the POST or PUT request
      this.axios.request({
        method,
        url,
        data: this.rank
      })
        .then((res) => {
          this.$router.push('/admin/devotional-completion-ranks')
        })
        .catch(this.$root.apiErrorHandler((msg, errors) => {
          this.errMessage = msg
          this.errors = errors
          this.isError = true
        }))
    },
    inputFocus (ev) {
      // Clear any errors for an input when it receives focus
      if (ev.target && ev.target.id) {
        this.errors[ev.target.id] = null
      }
    }
  }
}
</script>
